
import "../../styles/landing-pages/landing-pages.scss"
import { formParams } from '../general/form-ajax-post'
import { handleFormSubmit } from '../general/form-validation'
import axios from 'axios'

const bsn = require('bootstrap.native')
const btn_loader = '<div class="btn-loader"><div class="rect1"></div> <div class="rect2"></div> <div class="rect3"></div> <div class="rect4"></div> <div class="rect5"></div></div>'
const unsubAll = /** @type {HTMLInputElement} */ (document.getElementById('js-unsub-checkbox'));
const submitEl = /** @type {HTMLButtonElement} */ (document.getElementById('js-newsletter-preferences-submit'));

if (submitEl) {
    submitEl.disabled = true
}

// Get state of all checkboxes and uncheck based on sub/unsub all
let preferencesCheckboxes = /** @type {NodeListOf<HTMLInputElement>} */ (document.querySelectorAll('.js-preferences-checkbox'));
if (preferencesCheckboxes.length > 0) {
    preferencesCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('click', function() {
            submitEl.disabled = false;
            if (unsubAll) {
                if (checkbox.checked && unsubAll.checked) {
                    unsubAll.checked = false;
                }
            }
        })
    })
}

let mediumCheckboxes = document.querySelectorAll('.js-medium-checkbox');
if(mediumCheckboxes.length > 0) {
    mediumCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('click', function() {
            submitEl.disabled = false
        })
    })
}

if (unsubAll) {
    unsubAll.addEventListener('click', function (event) {
        submitEl.disabled = false;
        if(unsubAll.checked) {
            checkAll(false);
        } else {
            enableAllCheckboxes();
        }
    });
}

// If radio buttons (sub/unsub all)
let radioButtons = document.querySelectorAll('[type="radio"][name="email_sub"]');
if (radioButtons.length > 0) {
    radioButtons.forEach(button => {
        button.addEventListener('click', function (event) {
            submitEl.disabled = false;
        });
    });
}

let emailInput = document.getElementById('homepage-newsletter-email');
if (emailInput) {
    emailInput.addEventListener('keyup', function (event) {
        if (emailInput.value.length > 0) {
            submitEl.disabled = false;
        } else {
            submitEl.disabled = true;
        }
    });
}

function checkAll(check) {
    preferencesCheckboxes.forEach(checkbox => {
        checkbox.checked = check;
    });
}

function enableAllCheckboxes() {
    preferencesCheckboxes.forEach(checkbox => {
        checkbox.disabled = false;
    });
}

// Submitting the form
document.addEventListener('submit', async function (event) {
    const {
        language_switch,
    } = window.tg;

    event.preventDefault()

    // Capture the form element
    const formEl = /** @type {HTMLFormElement} */ document.getElementById("js-newsletter-preferences-form");

    if (event.target != formEl) {
        return;
    }

    const isEmailForm = formEl.classList.contains('email-form');
    const submitElInnerHTML = submitEl.innerHTML;
    const unsubPageSuccessBanner = document.getElementById('js-unsub-success-banner');
    const unsubPageErrorBanner = document.getElementById('js-unsub-error-banner');
    const macroSuccessBanner = document.getElementById('js-preference-update-banner-success');
    const macroErrorBanner = document.getElementById('js-preference-update-banner-error');

    submitEl.style.width = (Math.ceil(submitEl.offsetWidth) + 1) + 'px' // 2 for borders
    submitEl.disabled = true
    submitEl.innerHTML = btn_loader

    if (unsubPageSuccessBanner || unsubPageErrorBanner) {
        if(unsubPageSuccessBanner) {
            unsubPageSuccessBanner.classList.add('d-none');
            var preferencesContext = document.querySelectorAll('.js-preferences-header')
            preferencesContext.forEach(context => {
                context.classList.remove('d-none');
            });
        }
        if(unsubPageErrorBanner) {
            unsubPageErrorBanner.classList.add('d-none');
        }
    }

    if (macroSuccessBanner || macroErrorBanner) {
        if(macroSuccessBanner) {
            macroSuccessBanner.classList.add('d-none');
        }
        if(macroErrorBanner) {
            macroErrorBanner.classList.add('d-none');
        }
    }

    let validate = handleFormSubmit(formEl)

    if (validate) {
        try {
            if (formEl.action === '') {
                throw "Form action is empty"
            }
            let params = formParams(formEl)
            // add language_pref to params with value of the selected language
            params += '&language_pref=' + language_switch;

            // We need a csrf token for Lavender
            const csrfToken = await axios.get('/csrf-token').then(res => res.data.token);
            params += ('&csrf_token=' + csrfToken);

            params = Object.fromEntries(new URLSearchParams(params));

            if (formEl.id === 'js-newsletter-preferences-form') {
                axios({
                    headers: {
                        "Content-Type": "application/json",
                        'Accept': 'application/json',
                        "X-Requested-With": "XMLHttpRequest"
                    },
                    method: 'post',
                    url: formEl.action,
                    data: params
                })
                .then(function (response) {

                    const data = response.data

                    if (data.success === true) {

                        setTimeout(() => {
                            macroSuccessBanner.classList.remove('d-none');

                            if (!isEmailForm) {
                                macroSuccessBanner.scrollIntoView({ block: 'center', behavior: 'smooth' });
                            }

                            if(!macroErrorBanner.classList.contains('d-none')) {
                                macroErrorBanner.classList.add('d-none');
                            }

                            resetSubmitEl(true, isEmailForm)

                            if (isEmailForm) {
                                window.history.replaceState('', document.title, '/');
                            } else {
                                window.history.replaceState('', document.title, data.pref_url);
                            }
                        }, 2000);
                    } else {
                        setTimeout(() => {
                            macroErrorBanner.classList.remove('d-none');

                            if (!isEmailForm) {
                                macroSuccessBanner.scrollIntoView({ block: 'center', behavior: 'smooth' });
                            }

                            if(!macroSuccessBanner.classList.contains('d-none')) {
                                macroSuccessBanner.classList.add('d-none');
                            }

                            resetSubmitEl(false, isEmailForm)
                        }, 2000);
                    }
                })
            }
        } catch(e) {
            resetSubmitEl(false, isEmailForm)
        }
    } else {
        resetSubmitEl(false, isEmailForm)
    }
}, false)

function resetSubmitEl(disabled, isEmailForm = false) {
    submitEl.disabled = disabled;

    if (isEmailForm) {
        submitEl.innerHTML = _t('kd.global.subscribe_alt', 'Subscribe') + '<i class="fas fa-paper-plane ml-2"></i>';
    } else {
        submitEl.innerHTML = _t( "kd.user.update_preferences", "Update Preferences");
    }
}
